// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type PhoneNumberListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useListPhoneNumbers(): () => Promise<PhoneNumberListe> {
  const getAPI = useGetApi();
  return useCallback(
    async () => (await getAPI()).phonenumbers.listPhoneNumbers(),
    [getAPI]
  );
}
